import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'vxe-table/lib/index.css'
import './styles/global.css'
import './styles/side-menu.css'
import VXETable from 'vxe-table'
import XEUtils from 'xe-utils'
import LoadingPlugin from './composables/useLoading'
import TabsPlugin from './composables/useTabs'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

Vue.config.productionTip = false

const originalErrorHandler = Vue.config.errorHandler
Vue.config.errorHandler = (err, vm, info) => {
  if (err && err.message && (
    err.message.includes('ResizeObserver loop completed with undelivered notifications') ||
    err.message.includes('ResizeObserver loop limit exceeded')
  )) {
    return
  }
  if (err && (err.name === 'NavigationDuplicated' || err.message?.includes('Avoided redundant navigation'))) {
    return
  }
  if (originalErrorHandler) {
    originalErrorHandler(err, vm, info)
  }
}

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && (event.reason.name === 'NavigationDuplicated' ||
      event.reason.message?.includes('Avoided redundant navigation'))) {
    event.preventDefault()
    return false
  }
})

window.addEventListener('error', (event) => {
  if (event.message && (
    event.message.includes('ResizeObserver loop completed with undelivered notifications') ||
    event.message.includes('ResizeObserver loop limit exceeded')
  )) {
    event.preventDefault()
    event.stopPropagation()
  }
}, true)

const OriginalResizeObserver = window.ResizeObserver
if (OriginalResizeObserver) {
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      const debouncedCallback = debounce((entries, observer) => {
        callback(entries, observer)
      }, 100)
      super(debouncedCallback)
    }
  }
}

function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

Vue.use(Antd, {
  size: 'medium',
  locale: zhCN
})

Vue.use(LoadingPlugin)
Vue.use(TabsPlugin)

VXETable.setup({
  zIndex: 2000,
  table: {
    border: true,
    showOverflow: 'title',
    showHeaderOverflow: 'title'
  }
})

Vue.use(VXETable)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
